import { render } from "./service_people.vue?vue&type=template&id=45d3c34c&scoped=true"
import script from "./service_people.vue?vue&type=script&lang=js"
export * from "./service_people.vue?vue&type=script&lang=js"

import "./service_people.vue?vue&type=style&index=0&id=45d3c34c&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d3c34c"]])

export default __exports__